export enum EntityTypeEnum {
    ACCOUNT = "ACCOUNT"
}